import React, { useState, useEffect } from 'react';
import { citiesService } from '../../../services/api';
// Styles provided by RestaurantOnboarding.css

const CITIES_FALLBACK = [
  { id: 1,  name: 'Ibarra',        latitude: 0.3516,  longitude: -78.1222, meeting_area_stores: 500 },
  { id: 2,  name: 'Atuntaqui',     latitude: 0.3382,  longitude: -78.2126, meeting_area_stores: 4000 },
  { id: 3,  name: 'Quito',         latitude: -0.2295, longitude: -78.5243, meeting_area_stores: 15000 },
  { id: 4,  name: 'Guayaquil',     latitude: -2.1962, longitude: -79.8862, meeting_area_stores: 15000 },
  { id: 5,  name: 'Cuenca',        latitude: -2.9001, longitude: -79.0059, meeting_area_stores: 10000 },
  { id: 6,  name: 'Ambato',        latitude: -1.2543, longitude: -78.6270, meeting_area_stores: 8000 },
  { id: 7,  name: 'Loja',          latitude: -3.9931, longitude: -79.2042, meeting_area_stores: 8000 },
  { id: 8,  name: 'Riobamba',      latitude: -1.6635, longitude: -78.6548, meeting_area_stores: 8000 },
  { id: 9,  name: 'Manta',         latitude: -0.9677, longitude: -80.7089, meeting_area_stores: 8000 },
  { id: 10, name: 'Santo Domingo', latitude: -0.2522, longitude: -79.1719, meeting_area_stores: 10000 },
];

const StepRestaurantCity = ({ formData, onUpdate, errors = {}, onClearError }) => {
  const [cities,  setCities]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    citiesService.getAll()
      .then((res) => {
        const list = res?.data ?? res ?? CITIES_FALLBACK;
        setCities(Array.isArray(list) ? list : CITIES_FALLBACK);
      })
      .catch(() => setCities(CITIES_FALLBACK))
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (city) => {
    onUpdate({
      city_id:              city.id,
      city_lat:             city.latitude,
      city_lng:             city.longitude,
      city_meeting_area:            city.meeting_area_stores    ?? null,
      city_operating_hours: city.operating_hours ?? null,
      city_min_hours:       city.min_hours       ?? null,
      // Reset location when city changes
      latitude:    '',
      longitude:   '',
      out_of_range: false,
    });
    if (onClearError) onClearError('city_id');
  };

  return (
    <div className="ro-body ro-basic">

      <div className="ro-step-hd">
        <span className="ro-eyebrow ro-eyebrow--accent">Paso 5 · Ciudad</span>
        <h2 className="ro-title">¿En qué ciudad opera tu negocio?</h2>
        <p className="ro-subtitle">
          Selecciona la ciudad donde se encuentra tu local.
        </p>
      </div>

      {/* City grid */}
      {loading ? (
        <div className="ro-city-loading">
          <span className="ro-spin" />
        </div>
      ) : (
        <div className="ro-city-grid">
          {cities.map((city) => {
            const selected = formData.city_id === city.id;
            return (
              <button
                key={city.id}
                type="button"
                className={`ro-city-card${selected ? ' ro-city-card--sel' : ''}`}
                onClick={() => handleSelect(city)}
              >
                {selected && <span className="ro-city-card-check" aria-hidden>✓</span>}
                <div className="ro-city-thumb">
                  {city.image
                    ? <img src={city.image} alt={city.name} className="ro-city-thumb-img" />
                    : <span className="ro-city-icon" aria-hidden>🏙️</span>
                  }
                </div>
                <span className="ro-city-name">{city.name}</span>
              </button>
            );
          })}
        </div>
      )}

      {errors.city_id && (
        <span className="ro-err-msg ro-err-msg--block">{errors.city_id}</span>
      )}

    </div>
  );
};

export default StepRestaurantCity;
